export interface HeroSlide {
  movieId: string;
  image: string;
  tagline: string;
}

export const heroSlides: HeroSlide[] = [
  {
    movieId: 'xing-hai-yuan-zheng',
    image:
      'https://readdy.ai/api/search-image?query=Epic%20cinematic%20space%20scene%20of%20a%20massive%20spaceship%20gliding%20past%20a%20giant%20glowing%20ringed%20planet%2C%20deep%20navy%20blue%20cosmos%20with%20vivid%20orange%20and%20cyan%20nebula%20glow%2C%20stylized%20sci%20fi%20concept%20art%2C%20dramatic%20scale%20and%20atmosphere%2C%20no%20text%2C%20highly%20detailed%20wide%20composition&width=1920&height=900&seq=hero-slide-01&orientation=landscape',
    tagline: '年度硬核科幻巨制 · 一场驶向未知星系的壮阔远征',
  },
  {
    movieId: 'chang-ye-jiang-jin',
    image:
      'https://readdy.ai/api/search-image?query=Moody%20cinematic%20crime%20scene%20of%20a%20rain%20soaked%20city%20street%20at%20night%20with%20reflective%20neon%20streets%20and%20a%20lone%20silhouette%2C%20deep%20navy%20blue%20with%20warm%20amber%20streetlight%20glow%2C%20stylized%20film%20noir%20art%2C%20tense%20atmosphere%2C%20no%20text%2C%20highly%20detailed%20wide%20composition&width=1920&height=900&seq=hero-slide-02&orientation=landscape',
    tagline: '尘封十二年的旧案重启 · 冷峻硬核的国产悬疑之作',
  },
  {
    movieId: 'yan-huo-ren-jian',
    image:
      'https://readdy.ai/api/search-image?query=Cozy%20warm%20night%20street%20food%20market%20in%20an%20old%20Chinese%20city%20with%20glowing%20lanterns%20and%20steaming%20food%20stalls%2C%20warm%20amber%20and%20deep%20blue%20evening%20tones%2C%20stylized%20illustration%2C%20lively%20tender%20atmosphere%2C%20no%20text%2C%20highly%20detailed%20wide%20composition&width=1920&height=900&seq=hero-slide-03&orientation=landscape',
    tagline: '烟火气十足的群像生活流 · 深夜里最治愈的一碗人间',
  },
  {
    movieId: 'sha-qiu-zhi-wai',
    image:
      'https://readdy.ai/api/search-image?query=Vast%20desert%20epic%20scene%20of%20towering%20sand%20dunes%20beneath%20a%20twin%20moon%20sky%20with%20a%20tiny%20caravan%2C%20golden%20sand%20and%20deep%20indigo%20tones%2C%20stylized%20cinematic%20concept%20art%2C%20mythic%20awe%20inspiring%20atmosphere%2C%20no%20text%2C%20highly%20detailed%20wide%20composition&width=1920&height=900&seq=hero-slide-04&orientation=landscape',
    tagline: '沙漠美学新标杆 · 史诗级科幻冒险震撼上线',
  },
];